export interface TessaUserAssertionDependencies {
  configApi: {
    getOptionalString(key: string): string | undefined;
  };
  microsoftAuthApi: {
    getAccessToken(
      scope: string,
      options: { optional: false },
    ): Promise<string>;
  };
}

/**
 * Returns the signed-in user's Tessa access token (`api://<clientId>/access_as_user`),
 * or `undefined` when `tessaObo.clientId` is not configured. What a missing
 * client ID means is the caller's decision. Throws when the token is empty.
 */
export async function getTessaUserAssertion(
  dependencies: TessaUserAssertionDependencies,
): Promise<string | undefined> {
  const clientId = dependencies.configApi
    .getOptionalString('tessaObo.clientId')
    ?.trim();
  if (!clientId) return undefined;

  const assertion = await dependencies.microsoftAuthApi.getAccessToken(
    `api://${clientId}/access_as_user`,
    { optional: false },
  );
  if (!assertion.trim()) {
    throw new Error('No Tessa token received.');
  }
  return assertion;
}
